module.exports = __webpack_public_path__ + "static/img/6.fb80a96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/6.png
// module id = yzvC
// module chunks = 0